/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ProgramEnvironmentalBenefitsTargetValueViewer} from "./ProgramEnvironmentalBenefitsTargetValueViewer";
import autobind from "autobind-decorator";

export class MilestoneProgramEnvironmentalBenefitsTargetValueViewer extends ProgramEnvironmentalBenefitsTargetValueViewer {
	//override
	@autobind
	getSelectedBenefitId() {
		let ret = -1;
		let thisId = this.props.Data.milestoneId || this.props.Data._tempId;

		if (this.props.RootData.ProgramEnvironmentalBenefits) {
			this.props.RootData.ProgramEnvironmentalBenefits.forEach((x) => {
				if (x.Milestones && x.Milestones.some((y) => y.milestoneId == thisId)) {
					ret = x.environmentalBenefitId;
				}
			});
		}

		return ret;
	}
}